import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor(private http: HttpClient) { }


  get clientId() {
    return environment.clientId;
  }

  get clientSecret() {
    return environment.clientSecret;
  }

  get tokenScope() {
    return environment.tokenScope;
  }

  get refreshTokenScope() {
    return environment.refreshTokenScope;
  }

  get PortalWebApiUrl() {
    return environment.portalWebApiUrl;
  }

  get UserWebApiUrl() {
    return environment.userWebApiUrl;
  }

  get TokenApiUrl() {
    return environment.tokenApiUrl;
  }

  get issuesPortalUrl() {
    return environment.issuesPortalUrl;
  }

  get allowLocalizationChange() {
    return environment.allowLocalizationChange;
  }

  get enableFrontendImageCompression() {
    return environment.enableFrontendImageCompression;
  }

  get imageCompressionMaxWidth() {
    return environment.imageCompressionMaxWidth;
  }

  get imageCompressionMaxHeight() {
    return environment.imageCompressionMaxHeight;
  }

}
